import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_HOST } from '../../../core/api/api.config';
import { ApiService } from '../../../core/api/api.service';
import { ENDPOINTS } from '../../../core/api/endpoints';

@Injectable({
    providedIn: 'root',
})
export class JournalVoucherService {

    constructor(private api: ApiService) { }

    /* ================= GET VOUCHER LIST ================= */
    getVoucherList(): Observable<any[]> {
        return this.api.get(API_HOST.journal, ENDPOINTS.JOURNAL.GET_VOUCHERS);
    }

    /* ================= GET VOUCHER DETAILS ================= */
    getVoucherDetails(vchrSeq: number): Observable<any[]> {
        return this.api.get(
            API_HOST.journal,
            ENDPOINTS.JOURNAL.GET_VOUCHER_DETAILS + vchrSeq
        );
    }

    /* ================= MAP LIST ================= */
    mapVoucherList(res: any[]): any[] {
        return (res || []).map((item: any) => ({
            id: item.jrnlVchrSeq,
            parentId: item.prntJvSeq,
            voucherId: item.jrnVchrId,
            description: item.dscr,
            refKey: item.refKey,
            refType: item.refTypKey,
            branch: item.brnchSeq,
            date: this.fromIso(item.jrnlDt),
        }));
    }

    /* ================= MAP DETAILS ================= */
    mapVoucherDetails(res: any[]): any[] {
        return (res || []).map((item: any) => ({
            id: item.jrnlVchrDtlSeq,
            account: item.acctNbr,
            debit: Number(item.dbAmt || 0),
            credit: Number(item.crAmt || 0),
            description: item.dscr,
            itemNo: item.itmNbr,
        }));
    }

    /* ================= HELPERS ================= */
    private fromIso(date: string): string {
        return date ? date.split('T')[0] : '';
    }

    /* ================= SAVE ROLE ================= */
  saveRole(payload: any): Observable<any> {
    return this.api.post(
      API_HOST.setup,
      ENDPOINTS.ADMIN.SAVE_ROLE,
      payload
    );
  }

  /* ================= SAVE APP ACCESS ================= */
  saveAppAccess(payload: any): Observable<any> {
    return this.api.post(
      API_HOST.setup,
      ENDPOINTS.ADMIN.SAVE_APP_ACCESS,
      payload
    );
  }

  /* ================= GET AUTH LIST ================= */
  getAuthList(roleId: number): Observable<any> {
    return this.api.get(
      API_HOST.setup,
      ENDPOINTS.ADMIN.GET_AUTH_LIST + roleId
    );
  }

  /* ================= GET AUTH LIST FOR ROLE ================= */
  getAuthListForRole(roleSeq: number): Observable<any> {
    return this.api.get(
      API_HOST.setup,
      ENDPOINTS.ADMIN.GET_AUTH_LIST_FOR_ROLE + roleSeq
    );
  }

  /* ================= GET ALL SUB MODES ================= */
  getAllSubModes(): Observable<any> {
    return this.api.get(
      API_HOST.setup,
      ENDPOINTS.ADMIN.GET_ALL_SUB_MODES
    );
  }

  /* ================= GET ALL ROLES ================= */
  getAllRoles(): Observable<any> {
    return this.api.get(
      API_HOST.setup,
      ENDPOINTS.ADMIN.GET_ALL_ROLES
    );
  }

  /* ================= GET ALL MODES ================= */
  getAllModes(): Observable<any> {
    return this.api.get(
      API_HOST.setup,
      ENDPOINTS.ADMIN.GET_ALL_MODES
    );
  }

}